export enum StoreActionType {
  load,
  upsert
}
